/**
 * Entorno de desarrollo.
 *
 * La publishable key es pública por diseño: viaja en el bundle del navegador y
 * no concede ningún privilegio por sí sola. Toda la autorización vive en las
 * policies RLS de Postgres. Por eso se versiona, igual que en los repositorios
 * de referencia de la casa.
 */
export const environment = {
  production: false,
  supabaseUrl: 'https://rgsuwleobbpvynimofzl.supabase.co',
  supabaseAnonKey: 'sb_publishable_Bh7fhGpqczqBx7Ts565Rsg_jUSSauUS',
  appUrl: 'http://localhost:4200',
};
